import CustomerSearchContainers from '../../containers/customerSearch/customerSearchContainers';

function CustomerSearch() {
  return <CustomerSearchContainers />;
}

export default CustomerSearch;
